import { render, staticRenderFns } from "./giftCash.vue?vue&type=template&id=96fa2e54&"
import script from "./giftCash.vue?vue&type=script&lang=js&"
export * from "./giftCash.vue?vue&type=script&lang=js&"
import style0 from "./giftCash.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports